import { render, staticRenderFns } from "./SourcingForm.vue?vue&type=template&id=e820c1b2&scoped=true"
import script from "./SourcingForm.vue?vue&type=script&lang=js"
export * from "./SourcingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e820c1b2",
  null
  
)

export default component.exports